export default [{
        path: '/classroom/add',
        name: 'Admin.Classroom.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Form" */
                '@/views/Classroom/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Form',
            icon: "about"
        },
    },
    {
        path: '/classroom/:id/edit',
        name: 'Admin.Classroom.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Form" */
                '@/views/Classroom/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Form',
        },
    },
    {
        path: '/classroom/:id/detail',
        name: 'Admin.Classroom.Detail',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Detail" */
                '@/views/Classroom/Detail.vue'
            ),
        meta: {
            title: 'Classroom Detail',
        },
    },
    {
        path: '/classroom/:id/participants',
        name: 'Admin.Classroom.Participants',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Participants" */
                '@/views/Classroom/ParticipantList.vue'
            ),
        meta: {
            title: 'Classroom Participants',
        },
    },
    {
        path: '/classroom/:id/recommendation',
        name: 'Admin.Classroom.Recommendation',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Participants" */
                '@/views/Classroom/Recommendation/List.vue'
            ),
        meta: {
            title: 'Classroom Recomendation',
        },
    },
    {
        path: '/classroom/:id/webinar',
        name: 'Admin.Classroom.Webinar',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar" */
                '@/views/Classroom/Webinar/List.vue'
            ),
        meta: {
            title: 'List Webinar',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:id/edit',
        name: 'Admin.Classroom.Webinar.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Edit" */
                '@/views/Classroom/Webinar/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Webinar',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/add',
        name: 'Admin.Classroom.Webinar.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Add" */
                '@/views/Classroom/Webinar/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Webinar',
        },
    },
    {
        path: '/classroom/:classroomId/step/webinar/',
        name: 'Admin.Classroom.Webinar.Step',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Add" */
                '@/views/Classroom/Webinar/FormAlt.vue'
            ),
        meta: {
            title: 'Step 3: Add Webinar and Webinar Quiz',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:id/participants',
        name: 'Admin.Classroom.Webinar.Participant',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Participant" */
                '@/views/Classroom/Webinar/ParticipantList.vue'
            ),
        meta: {
            title: 'Classroom Participant Webinar',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:id/quiz',
        name: 'Admin.Classroom.Webinar.Quiz',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Quiz" */
                '@/views/Classroom/WebinarQuiz/List.vue'
            ),
        meta: {
            title: 'Classroom Webinar Quiz',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:webinarId/quiz/add',
        name: 'Admin.Classroom.Webinar.Quiz.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Quiz.Add" */
                '@/views/Classroom/WebinarQuiz/Form.vue'
            ),
        meta: {
            title: 'Classroom Webinar Quiz Add',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:webinarId/quiz/:id/edit',
        name: 'Admin.Classroom.Webinar.Quiz.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Quiz.Edit" */
                '@/views/Classroom/WebinarQuiz/Form.vue'
            ),
        meta: {
            title: 'Classroom Webinar Quiz Edit',
        },
    },
    {
        path: '/classroom/:classroomId/webinar/:webinarId/quiz/:id/question',
        name: 'Admin.Classroom.Webinar.Quiz.Question',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Webinar.Quiz.Question" */
                '@/views/Classroom/WebinarQuiz/QuestionList.vue'
            ),
        meta: {
            title: 'Classroom Webinar Quiz Question List',
        },
    },
    {
        path: '/classroom/:id/subject',
        name: 'Admin.Classroom.Subject',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject" */
                '@/views/Classroom/Subject/ListAlt.vue'
            ),
        meta: {
            title: 'Video List',
        },
    },
    {
        path: '/classroom/:classroomId/subject/:id/edit/',
        name: 'Admin.Classroom.Subject.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Edit" */
                '@/views/Classroom/Subject/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Subject',
        },
    },
    {
        path: '/classroom/:classroomId/subject/add',
        name: 'Admin.Classroom.Subject.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Add" */
                '@/views/Classroom/Subject/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Subject',
        },
    },
    {
        path: '/classroom/:classroomId/step/subject/',
        name: 'Admin.Classroom.Subject.Step',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Add" */
                '@/views/Classroom/Subject/FormAlt.vue'
            ),
        meta: {
            title: 'Step 1: Add Subject',
        },
    },
    {
        path: '/classroom/:classroomId/subject/:id/detail/',
        name: 'Admin.Classroom.Subject.Detail',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Detail" */
                '@/views/Classroom/Subject/Detail.vue'
            ),
        meta: {
            title: 'Classroom Subject Detail',
        },
    },

    {
        path: '/classroom/:id/modul',
        name: 'Admin.Classroom.Modul',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Modul" */
                '@/views/Classroom/Modul/ListAlt.vue'
            ),
        meta: {
            title: 'List Modul',
        },
    },
    {
        path: '/classroom/:classroomId/modul/:id/edit',
        name: 'Admin.Classroom.Modul.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Modul.Edit" */
                '@/views/Classroom/Modul/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Modul',
        },
    },
    {
        path: '/classroom/:classroomId/modul/add',
        name: 'Admin.Classroom.Modul.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Modul.Add" */
                '@/views/Classroom/Modul/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Modul',
        },
    },
    {
        path: '/classroom/:classroomId/modul/:id/detail',
        name: 'Admin.Classroom.Modul.Detail',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Modul.Detail" */
                '@/views/Classroom/Modul/Detail.vue'
            ),
        meta: {
            title: 'Classroom Detail Modul',
        },
    },
    {
        path: '/classroom/:classroomId/step/modul/',
        name: 'Admin.Classroom.Modul.Step',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Add" */
                '@/views/Classroom/Modul/FormAlt.vue'
            ),
        meta: {
            title: 'Step 2: Add Module',
        },
    },

    {
        path: '/classroom/:id/quiz',
        name: 'Admin.Classroom.Quiz',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Quiz" */
                '@/views/Classroom/Quiz/ListAlt.vue'
            ),
        meta: {
            title: 'Classroom Quiz',
        },
    },
    {
        path: '/classroom/:classroomId/quiz/:id/question',
        name: 'Admin.Classroom.Quiz.Question',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Quiz.Question" */
                '@/views/Classroom/Quiz/QuestionList.vue'
            ),
        meta: {
            title: 'Classroom Quiz Question List',
        },
    },
    {
        path: '/classroom/:classroomId/quiz/add',
        name: 'Admin.Classroom.Quiz.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Quiz.Add" */
                '@/views/Classroom/Quiz/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Quiz',
        },
    },
    {
        path: '/classroom/:classroomId/quiz/:id/edit',
        name: 'Admin.Classroom.Quiz.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Quiz.Edit" */
                '@/views/Classroom/Quiz/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Webinar Record',
        },
    },
    {
        path: '/classroom/:classroomId/step/quiz/',
        name: 'Admin.Classroom.Quiz.Step',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Subject.Add" */
                '@/views/Classroom/Quiz/FormAlt.vue'
            ),
        meta: {
            title: 'Step 4: Add Quiz and Exam',
        },
    },
    {
        path: '/classroom/:id/webinar-record',
        name: 'Admin.Classroom.WebinarRecord',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.WebinarRecord" */
                '@/views/Classroom/WebinarRecord/List.vue'
            ),
        meta: {
            title: 'Classroom Webinar Record',
        },
    },
    {
        path: '/classroom/:classroomId/webinar-record/add',
        name: 'Admin.Classroom.WebinarRecord.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.WebinarRecord.Add" */
                '@/views/Classroom/WebinarRecord/Form.vue'
            ),
        meta: {
            title: 'Classroom Add Webinar Record',
        },
    },
    {
        path: '/classroom/:classroomId/webinar-record/:id/edit',
        name: 'Admin.Classroom.WebinarRecord.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.WebinarRecord.Edit" */
                '@/views/Classroom/WebinarRecord/Form.vue'
            ),
        meta: {
            title: 'Classroom Edit Webinar Record',
        },
    },
    {
        path: '/classroom/category',
        name: 'Admin.Classroom.Category',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Category" */
                '@/views/Classroom/Category/List.vue'
            ),
        meta: {
            title: 'Classroom Category List',
        },
    },
    {
        path: '/classroom/category/add',
        name: 'Admin.Classroom.Category.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Category.Add" */
                '@/views/Classroom/Category/Form.vue'
            ),
        meta: {
            title: 'Classroom Category Add',
        },
    },
    {
        path: '/classroom/category/:id/edit',
        name: 'Admin.Classroom.Category.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Category.Edit" */
                '@/views/Classroom/Category/Form.vue'
            ),
        meta: {
            title: 'Classroom Category Edit',
        },
    },
    {
        path: '/classroom/free/',
        name: 'Admin.Classroom.Free.List',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Free.List" */
                '@/views/Classroom/Free/List.vue'
            ),
        meta: {
            title: 'Classroom Free List',
        },
    },
    {
        path: '/classroom/free/add',
        name: 'Admin.Classroom.Free.Add',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Free.Add" */
                '@/views/Classroom/Free/Form.vue'
            ),
        meta: {
            title: 'Classroom Free Add',
        },
    },
    {
        path: '/classroom/free/:id/edit',
        name: 'Admin.Classroom.Free.Edit',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Free.Edit" */
                '@/views/Classroom/Free/Form.vue'
            ),
        meta: {
            title: 'Classroom Free Edit',
        },
    },
    {
        path: '/classroom/hot/',
        name: 'Admin.Classroom.Hot.List',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Hot.List" */
                '@/views/Classroom/Hot/List.vue'
            ),
        meta: {
            title: 'Classroom Hot List',
        },
    },
    {
        path: '/classroom/:classroomId/review',
        name: 'Admin.Classroom.Review',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Review" */
                '@/views/Classroom/Review/List.vue'
            ),
        meta: {
            title: 'Classroom Review'
        },
    },
    {
        path: '/classroom/:classroomId/task/',
        name: 'Admin.Classroom.Task.List',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Task.List" */
                '@/views/Classroom/Task/List.vue'
            ),
        meta: {
            title: 'Classroom Task List'
        }
    },
    {
        path: '/classroom/:classroomId/step/task/',
        name: 'Admin.Classroom.Task.Step',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Task.Step" */
                '@/views/Classroom/Task/FormAlt.vue'
            ),
        meta: {
            title: 'Step 5: Add Task'
        }
    },
    {
        path: '/classroom/:classroomId/pre-post-test',
        name: 'Admin.Classroom.Test.List',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Test.List" */
                '@/views/Classroom/PrePostTest/List.vue'
            ),
        meta: {
            title: 'Classroom Pre/Post-Test List'
        }
    },
    {
        path: '/classroom/:classroomId/material',
        name: 'Admin.Classroom.Material.List',
        component: () =>
            import (
                /* webpackChunkName: "Admin.Classroom.Material.List" */
                '@/views/Classroom/Material/List.vue'
            ),
        meta: {
            title: 'Classroom Material List'
        }
    },
    {
        path: '/classroom/:classroomId/question',
        name: 'Admin.Classroom.Question.List',
        component: () =>
            import (
                '@/views/Classroom/Question/List.vue'
            ),
        meta: {
            title: "Classroom User Question"
        }
    },
]